import { useEffect } from 'react';

export const useDocumentTitle = (title: string, badge?: number): void => {
  useEffect(() => {
    const formattedTitle = badge && badge > 0 ? `(${badge}) ${title}` : title;
    document.title = formattedTitle;

    return () => {
      document.title = 'Tacit CRM';
    };
  }, [title, badge]);
};
